import { Spinner } from '@aus-platform/design-system';
import { isNil } from 'lodash';
import type { ReactNode } from 'react';
import { CopyableText } from 'src/shared/components';
import { BatchJobStatus, DSMStatus, TerrainTileStatus } from 'src/shared/enums';
import { TerrainIterationStatus } from './enums';

type MeasurementInfoProps = {
  label: string | ReactNode;
  value: number | null;
  unit?: string;
  isLoading: boolean;
  terrainIterationId?: string | null;
  dsmStatus?: DSMStatus;
  dsmCogStatus?: BatchJobStatus;
  terrainTileStatus?: TerrainTileStatus;
};

export const MeasurementInfo: React.FC<MeasurementInfoProps> = ({
  label,
  value,
  unit = 'm',
  isLoading,
  terrainIterationId,
  dsmStatus,
  dsmCogStatus,
  terrainTileStatus,
}) => {
  if (dsmStatus === DSMStatus.Deleted) {
    return null;
  }

  const terrainIterationStatus = (): TerrainIterationStatus => {
    // TODO: The below logic is a patch, and needs to be improved and refactored.
    if (!terrainIterationId) {
      return TerrainIterationStatus.NotFound;
    }
    if (terrainTileStatus === TerrainTileStatus.Failed) {
      return TerrainIterationStatus.Failed;
    }
    if (dsmStatus === DSMStatus.NotFound) {
      return TerrainIterationStatus.NotFound;
    }
    if (dsmStatus === DSMStatus.Failed) {
      return TerrainIterationStatus.Failed;
    }
    if (dsmStatus === DSMStatus.Processing || dsmStatus === DSMStatus.Started) {
      return TerrainIterationStatus.Processing;
    }
    if (dsmStatus === DSMStatus.Done) {
      if (
        dsmCogStatus === BatchJobStatus.Processing ||
        dsmCogStatus === BatchJobStatus.Started
      ) {
        return TerrainIterationStatus.Processing;
      }
      if (dsmCogStatus === BatchJobStatus.Failed) {
        return TerrainIterationStatus.Failed;
      }
      if (dsmCogStatus === BatchJobStatus.NotFound) {
        return TerrainIterationStatus.NotFound;
      }
    }
    return TerrainIterationStatus.OutOfBounds;
  };

  if (!isNil(value) && terrainTileStatus !== TerrainTileStatus.Failed) {
    return (
      <CopyableText
        header={label}
        value={`${value} ${unit}`}
        isLoading={isLoading}
      />
    );
  }

  return (
    <div className="measurement-info">
      <div className="measurement-info__label">{label}</div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="measurement-info__value">
          {terrainIterationStatus()}
        </div>
      )}
    </div>
  );
};
